import type { DocumentTemplateSummary } from '../types/documentTemplates.types';

export interface TemplateOption {
  value: string;
  label: string;
}

export function toTemplateOptions(templates: readonly DocumentTemplateSummary[]): TemplateOption[] {
  return templates.map((template) => ({
    value: template.id,
    label: `${template.name} (${template.owner === 'platform' ? 'Platform' : 'Dealer'}, live v${template.published?.versionNumber ?? '?'})`,
  }));
}

export function truncationNotice(shown: number, total: number, noun: string): string | undefined {
  return total > shown ? `Showing the first ${shown} ${noun}. More exist.` : undefined;
}
